export function getParams(state) {
	return state.params
}


// WEBPACK FOOTER //
// ./src/modules/ordersManagement/getters.js